<template>
  <!--not neccessary anymore-->
  <!--shown, when user logs out-->
  <div class="card" v-if="!token">
    <h1 class="h2 mb-5 font-weight-bold text-center d-flex align-items-center justify-content-center">
      <comline-logo :fill="'#212529'" :height="'40px'" :width="'40px'" class="mb-0 mr-2 d-flex align-items-center" />
      ChargeLine
    </h1>
    <div v-if="error" class="alert alert-danger">{{ error }}</div>
    <p>Bitte melde dich über das ComLine Prtal an.</p>
    <button @click="openLogIn()" class="bt btn-primary">Portal</button>
  </div>
  <div v-else>
    <pulse-loader :color="'rgba(64, 137, 201, 1)'"/>
  </div>
</template>

<script>
import PulseLoader from 'vue-spinner/src/ClipLoader.vue';
import ComlineLogo from "../assets/ComlineLogo.vue";
import { signInWithEmailAndPassword, signInWithCustomToken } from "firebase/auth";
import { auth } from "../plugins/firebase/index";
import { Browser } from '@capacitor/browser';

export default {
  name: "LoginView",
  components: {
    ComlineLogo,
    PulseLoader
  },
  data() {
    return {
      token: this.$route.params.token,
      email: "",
      password: "",
      states: {
        email: null,
      },
      error: null,
    };
  },
  methods: {
    async submit() {
      //login with email and password
      console.log(`LOGGING IN! with ${this.email} - ${this.password}`)
      this.error = ""
      try{
        await signInWithEmailAndPassword(auth, this.email, this.password)
        this.$router.push({ name: 'calendar' })
      }        
      catch(error){
        console.log("LOGGING IN - ERROR")
        this.error = error.message;
      }
      console.log("AFTER FUNCTION")
    },
    async openLogIn() {
      // 59bMfgXgHuahKAgDrqWf ist die Datenbank ID in Portal.comline.app....
      await Browser.open({ url: 'https://portal.comline.app/inapplogin/59bMfgXgHuahKAgDrqWf' });
    }
  },
  mounted() {
    //checks for token in url
    console.log("LOGIN MOUNTED")
    if (this.token) {
      //login with costum token
      signInWithCustomToken(auth, this.token)
        .then(() => {
          // navigate tocalendar, if authentic token
          this.$router.push({ name: 'calendar' })
        })
        .catch(err => { 
          this.token = false
          console.error(err) })
    }
  }
};
</script>

<style scoped>
.card {
  max-width: 300px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  padding: 50px;
  border: 1px solid #dedede;
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: rgb(222, 222, 222);
  border-radius: 0.35rem;
  border-top: 5px solid #4089c9;
  margin: auto;
}

input {
  padding: 5px 10px;
  width: calc(100% - 20px);
  border-radius: 5px;
  border: 1px solid #dedede;
  font-size: 1.1em;
  margin-bottom: 20px;
}

svg {
  top: 8px;
  position: relative;
  margin-right: 10px;
}

button {
  background-color: #4089c9;
  border: none;
  color: #fff;
  width: 100%;
  border-radius: 5px;
  font-size: 1.1em;
  outline: none;
  padding: 5px 2px;
  margin-top: 10px;
}

label {
  text-align: start;
  float: left;
  margin-bottom: 5px;
}
</style>